<template>
  <div class="form_card">
    <div class="form_card__header" v-if="hasHeader">
      <div class="form_card__title" v-if="hasTitle">
        <b-switch v-if="optional" v-model="isToggled" />

        <span class="t-label t-label--dark">
          <slot name="title"></slot>

          <template v-if="!this.$slots.title">
            {{ title }}
          </template>
        </span>
      </div>

      <div class="form_card__header_controls" v-if="hasControls && isToggled">
        <div class="form_card__header_controls_content">
          <slot name="controls"></slot>
        </div>
      </div>
    </div>

    <transition name="anim-slideX">
      <div v-if="isToggled">
        <div class="form_card__body">
          <slot></slot>
        </div>

        <div
          class="form_card__illustration_row"
          v-if="this.$slots.illustration"
        >
          <slot name="illustration"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isToggled: this.value,
    };
  },

  computed: {
    hasTitle() {
      return this.title !== null || this.$slots.title;
    },

    hasControls() {
      return !!this.$slots.controls;
    },
    hasHeader() {
      return this.hasTitle || this.hasControls;
    },
  },

  watch: {
    isToggled(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.form_card {
  position: relative;
  background-color: #fff;
  padding: 16px 20px;
  margin-left: -8px;
  margin-right: -8px;

  &:first-child {
    margin-top: -8px;
  }

  //modifiers
  &:not(:last-child) {
    margin-bottom: 8px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  &__header_controls {
    position: relative;
    z-index: 1;
    margin-left: auto;
  }

  &__header_controls_content {
    right: 0;
    position: absolute;
    white-space: nowrap;
  }

  &__illustration_row {
    // display: flex;
    // justify-content: flex-end;
    margin-top: 42px;
    width: 330px;
    margin-left: auto;

    img {
      width: 330px;
    }
  }
}
</style>
